module.exports = __webpack_public_path__ + "static/img/bg.a1ccb34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taoyuan/bg.png
// module id = L/ze
// module chunks = 1